document.addEventListener("DOMContentLoaded", function() {
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach((item, index) => {
        const question = item.querySelector('.question');
        const answerWrapper = item.querySelector('.answer-wrapper');
        const arrowIcon = question.querySelector('.arrow-icon');

        // Automatically open the first question
        if (index === 0) {
            answerWrapper.style.maxHeight = answerWrapper.scrollHeight + "px";
            arrowIcon.classList.add('rotate-180-arrow');
        }

        question.addEventListener('click', () => {
            const isOpen = answerWrapper.style.maxHeight;

            // Close all other answers and reset their arrows
            faqItems.forEach(otherItem => {
                const otherWrapper = otherItem.querySelector('.answer-wrapper');
                const otherArrow = otherItem.querySelector('.arrow-icon');
                otherWrapper.style.maxHeight = null;
                otherArrow.classList.remove('rotate-180-arrow');
            });

            // Toggle the clicked answer
            if (!isOpen) {
                answerWrapper.style.maxHeight = answerWrapper.scrollHeight + "px";
                arrowIcon.classList.add('rotate-180-arrow');
            } else {
                arrowIcon.classList.remove('rotate-180-arrow');
            }
        });
    });
});
